// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/aerodrome-symbols.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/aerodrome-symbols/aerodrome-symbols.js';
import g1 from '../lessons/navigation/aerodrome-symbols/airspace-area-symbols.js';
import g2 from '../lessons/navigation/aerodrome-symbols/obstacle-symbols.js';
import g3 from '../lessons/navigation/aerodrome-symbols/town-symbols.js';

mount([g0, g1, g2, g3]);
